// La page vit entièrement dans public/index.html (statique, aucun besoin de
// React) — ce point d'entrée ne monte l'app que si un #root existe, pour ne
// pas jeter d'erreur console sur la page statique.
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

const container = document.getElementById('root');
if (container) {
  const root = ReactDOM.createRoot(container);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}
